import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

// MSAL v5 silent renewals load the redirectUri in a hidden iframe and wait for
// the response over a BroadcastChannel: hand it over without loading the app,
// which would not fit in the iframe timeout and would report the auth code to
// analytics.
const isMsalSilentResponse =
  window.parent !== window &&
  new URLSearchParams(window.location.hash.substring(1)).has('state');

if (isMsalSilentResponse) {
  broadcastResponseToMainFrame().catch(error => console.warn(error));
} else {
  import('src/bootstrap');
}
